import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const EditPencilIconFilled = ({ color, ...rest }) => (

    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 18" {...rest}>
    {/* <svg xmlns="http://www.w3.org/2000/svg" xmlns: xlink="http://www.w3.org/1999/xlink" width="17" height="18" viewBox="0 0 17 18"> */}
        <defs>
            <path id="a" d="M0 .19h5.371v5.524H.001z" />
            <path id="c" d="M0 .139h5.886v6.079H0z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
            <path fill={color} d="M6.554 15.193l-.314.372c2.714-3.029 5.428-6 8.2-8.972l-3.772-3.428c-2.657 2.885-5.285 5.8-7.971 8.628l3.857 3.4z" />
            <g transform="translate(.583 12.147)">
                <mask id="b" fill="#fff">
                    <use href="#a"/>
                    {/* <use xlink:href="#a"/> */}
            </mask>
                <path fill={color} d="M1.486.19c-.172.2-.343.37-.515.542C.886.818.886.818.886.904L0 5.332V5.532c.086.172.286.229.429.143L4.6 4.36c.057 0 .143-.029.171-.086.2-.229.4-.429.6-.657L1.486.189z" mask="url(#b)" />
            </g>
            <g transform="translate(11.154 .147)">
                <mask id="d" fill="#fff">
                    <use href="#c"/>
                    {/* <use xlink:href="#c"/> */}
            </mask>
                <path fill={color} d="M5.286 1.39L4.4.59C3.971.245 3.429.074 2.886.16a1.8 1.8 0 0 0-1.429.715C.971 1.418.486 1.932 0 2.475l3.771 3.428-.285.315c.6-.629 1.2-1.286 1.771-1.915a2.66 2.66 0 0 0 .629-1.485c0-.572-.229-1.057-.6-1.429" mask="url(#d)" />
            </g>
        </g>
    </svg>


)
/* --------------------------------------------- */
EditPencilIconFilled.propTypes = {
    /** Color of icon. */
    color: PropTypes.string,
    /** Icon css styles. */
    style: PropTypes.object
}
/* --------------------------------------------- */
EditPencilIconFilled.defaultProps = {
    color: 'transparent',

}
/* --------------------------------------------- */
export default EditPencilIconFilled
/* --------------------------------------------- */
